/**
 * @desc 获取多个SKU报价信息
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/getSupplierQuotationBySkuList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
